import httpHubless from 'hub-http/clients/noPortalApiClient';
import Endpoints from '../constants/apiEndpoints';
import { Record, Iterable, fromJS, Map as ImmutableMap, List } from 'immutable';
import TwoFactorRequestStatus from '../constants/TwoFactorRequestStatus';
import TwoFactorAuthMethod from '../constants/twoFactorAuthMethod';
const TwoFactorAuthConfig = Record({
  status: TwoFactorRequestStatus.PENDING,
  setupTime: null,
  method: TwoFactorAuthMethod.GOOGLE_AUTHENTICATOR,
  info: null
}, 'TwoFactorAuthConfig');
export class TwoFactorAuthStatus extends Record({
  primary: null,
  secondary: null,
  enabled: false,
  backupCodesResponse: ImmutableMap({
    backupCodes: List(),
    createdAt: null
  })
}, 'TwoFactorAuthStatus') {}
function fromJSReviver(key, value) {
  const isIndexed = Iterable.isIndexed(value);
  if (key === 'primary' || key === 'secondary') {
    return new TwoFactorAuthConfig(value);
  }
  return isIndexed ? value.toList() : value.toMap();
}
export function fromJSON(obj) {
  return new TwoFactorAuthStatus(fromJS(obj, fromJSReviver));
}
const fetchStatus = () => new Promise((resolve, reject) => {
  httpHubless.get(Endpoints.TWO_FACTOR_STATUS).then(result => {
    resolve(result);
  }).catch(err => reject(err));
});
export default fetchStatus;